<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row>
            <div class="title-box">
              <el-image :src="cheImage" class="title-label"></el-image>线路信息
            </div>
            <el-col :span="11">
              <el-form-item label="线路类型" prop="lineType">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="form.lineType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.lineTypeOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="arrow-box">
              <div>&nbsp;</div>
            </el-col>
            <el-col :span="11">
              <el-form-item label="公里数" prop="kilometres">
                <el-input
                  style="width: 100%"
                  v-model="form.kilometres"
                  clearable
                  autocomplete="off"
                  placeholder="请输入公里数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="运输线路" prop="startDot">
                <el-cascader
                  key="el2"
                  style="width: 100%"
                  :options="options"
                  ref="cascaderStart"
                  v-model="form.startDot"
                  @change="handleChangeStart"
                  :props="cityProps"
                  placeholder="请选择至区/县"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="arrow-box">
              <el-image :src="arrowImage" class="arrow-img"></el-image>
            </el-col>
            <el-col :span="11" style="padding-top: 0.3rem">
              <el-form-item prop="endDot">
                <el-cascader
                  key="el3"
                  style="width: 100%"
                  :options="options"
                  ref="cascaderEnd"
                  @change="handleChangeEnd"
                  v-model="form.endDot"
                  placeholder="请选择至区/县"
                  :props="cityProps"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>计费规则
          </div>
          <el-row :gutter="20">
            <el-col :span="8" v-for="(item, index) in form.rules" :key="index">
              <el-form-item
                v-if="index < form.rules.length -1"
                :prop="'rules.' + index + '.price'"
                :rules="rules.price"
                :label="`${item.left}-${item.right}t(包含${item.right}t)`"
              >
                <el-input
                  v-model="item.price"
                  clearable
                  autocomplete="off"
                  maxlength="11"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
              <el-form-item
                v-else
                :prop="'rules.' + index + '.price'"
                :rules="rules.price"
                :label="`${item.left}t以上`"
              >
                <el-input
                  v-model="item.price"
                  clearable
                  autocomplete="off"
                  maxlength="11"
                  placeholder="请输入"
                >
                  <div slot="append">元</div>
                </el-input>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="8">-->
            <!--              <el-form-item prop="companyType" label="0.3-0.5t（含0.5t）">-->
            <!--                <el-input-->
            <!--                  v-model="form.companyName"-->
            <!--                  clearable-->
            <!--                  autocomplete="off"-->
            <!--                  maxlength="11"-->
            <!--                  placeholder="请输入"-->
            <!--                >-->
            <!--                  <div slot="append">元</div>-->
            <!--                </el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item prop="companyType" label="0.5-1t（含1t）">-->
            <!--                <el-input-->
            <!--                  v-model="form.companyName"-->
            <!--                  clearable-->
            <!--                  autocomplete="off"-->
            <!--                  maxlength="11"-->
            <!--                  placeholder="请输入"-->
            <!--                >-->
            <!--                  <div slot="append">元</div>-->
            <!--                </el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item prop="companyType" label="1-1.5t（含1.5t）">-->
            <!--                <el-input-->
            <!--                  v-model="form.companyName"-->
            <!--                  clearable-->
            <!--                  autocomplete="off"-->
            <!--                  maxlength="11"-->
            <!--                  placeholder="请输入"-->
            <!--                >-->
            <!--                  <div slot="append">元</div>-->
            <!--                </el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item prop="companyType" label="1.5-2t（含2t）">-->
            <!--                <el-input-->
            <!--                  v-model="form.companyName"-->
            <!--                  clearable-->
            <!--                  autocomplete="off"-->
            <!--                  maxlength="11"-->
            <!--                  placeholder="请输入"-->
            <!--                >-->
            <!--                  <div slot="append">元</div>-->
            <!--                </el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item prop="companyType" label="2-3t（含3t）">-->
            <!--                <el-input-->
            <!--                  v-model="form.companyName"-->
            <!--                  clearable-->
            <!--                  autocomplete="off"-->
            <!--                  maxlength="11"-->
            <!--                  placeholder="请输入"-->
            <!--                >-->
            <!--                  <div slot="append">元</div>-->
            <!--                </el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo } from "./api";
import { getAreaNext } from "@/views/commonApi";
import { getSelectCompany } from "@/views/SystemManagement/CompanyManagement/api";
import { validatePrice } from "@/utils/validate";
import { setAreaTree } from "@/utils";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "添加",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      cityProps: {
        value: "areaCode",
        label: "areaExtName",
        checkStrictly: true,
      },
      // city1Props: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   lazyLoad(node, resolve) {
      //     // setTimeout(() => {
      //     const nodes = [];
      //     let query = {};
      //     // 构造查询条件
      //     if (node.value) {
      //       query = {
      //         code: node.value,
      //       };
      //     }
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       res.data.map((item) => {
      //         let obj = {
      //           value: item.areaCode,
      //           label: item.areaName,
      //           leaf: item.areaLevel === 2,
      //           disabled: item.areaLevel <= 1,
      //         };
      //         nodes.push(obj);
      //       });
      //       //重新加载节点
      //       resolve(nodes);
      //     });
      //     // }, 500);
      //   },
      // },
      form: {
        pricingId: "",
        lineType: 1,
        kilometres: "",
        endCityCode: "",
        endCityName: "",
        endDistrictCode: "",
        endDistrictName: "",
        endProvinceCode: "",
        endProvinceName: "",
        startCityCode: "",
        startCityName: "",
        startProvinceCode: "",
        startProvinceName: "",
        startDistrictCode: "",
        startDistrictName: "",
        startDot: [],
        endDot: [],
        rules: [
          {
            left: 0,
            price: "",
            right: 0.3,
          },
          {
            left: 0.3,
            price: "",
            right: 0.5,
          },
          {
            left: 0.5,
            price: "",
            right: 1,
          },
          {
            left: 1,
            price: "",
            right: 1.5,
          },
          {
            left: 1.5,
            price: "",
            right: 2,
          },
          {
            left: 2,
            price: "",
            right: 3,
          },
          {
            left: 3,
            price: "",
            right: 1000000000.0,
          },
        ],
      },
      rules: {
        lineType: [{ required: true, message: "线路类型不能为空" }],
        // kilometres: [{ required: true, message: "公里数不能为空" }],
        startDot: [{ required: true, message: "线路起点不能为空" }],
        endDot: [{ required: true, message: "线路终点不能为空" }],
        companyIds: [{ required: true, message: "公司不能为空" }],
        price: [
          { required: true, message: "金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
      arrowImage: require("@/assets/imgs/arroy.png"),
      companyList: [],
    };
  },
  computed: {
    options: function() {
      let treeData = JSON.parse(localStorage.getItem("area")) || []
      return setAreaTree(treeData, 2)
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleChangeStart() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.startProvinceCode = "";
      this.form.startProvinceName = "";
      this.form.startCityCode = "";
      this.form.startCityName = "";
      this.form.startDistrictCode = "";
      this.form.startDistrictName = "";
      const nodes = this.$refs.cascaderStart.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.startProvinceCode = node.value;
          this.form.startProvinceName = node.label;
        } else if (index === 1) {
          this.form.startCityCode = node.value;
          this.form.startCityName = node.label;
        } else if (index === 2) {
          this.form.startDistrictCode = node.value;
          this.form.startDistrictName = node.label;
        }
      });
      // // console.log("选中的名称start:", this.start);
    },
    handleChangeEnd() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.endProvinceCode = "";
      this.form.endProvinceName = "";
      this.form.endCityCode = "";
      this.form.endCityName = "";
      this.form.endDistrictName = "";
      this.form.endDistrictCode = "";
      const nodes = this.$refs.cascaderEnd.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.endProvinceCode = node.value;
          this.form.endProvinceName = node.label;
        } else if (index === 1) {
          this.form.endCityCode = node.value;
          this.form.endCityName = node.label;
        } else if (index === 2) {
          this.form.endDistrictCode = node.value;
          this.form.endDistrictName = node.label;
        }
      });
      // // console.log("选中的名称end:", this.end);
    },
    getDetail(pricingId) {
      this.loading = true;
      detailInfo(pricingId)
        .then((res) => {
          if (res.code === 200) {
            let arr1 = [res.data.startProvinceCode, res.data.startCityCode];
            let arr2 = [res.data.endProvinceCode, res.data.endCityCode];
            this.form.startDot = [...arr1];
            this.form.endDot = [...arr2];
            this.form.pricingId = res.data.pricingId;
            this.form.endCityCode = res.data.endCityCode;
            this.form.endCityName = res.data.endCityName;
            this.form.endProvinceCode = res.data.endProvinceCode;
            this.form.endProvinceName = res.data.endProvinceName;
            this.form.endDistrictCode = res.data.endDistrictCode;
            this.form.endDistrictName = res.data.endDistrictName;
            this.form.startCityCode = res.data.startCityCode;
            this.form.startCityName = res.data.startCityName;
            this.form.startProvinceCode = res.data.startProvinceCode;
            this.form.startProvinceName = res.data.startProvinceName;
            this.form.startDistrictCode = res.data.startDistrictCode;
            this.form.startDistrictName = res.data.startDistrictName;
            this.form.rules = res.data.rules;
            this.form.kilometres = res.data.kilometres;

            // // console.log(this.form);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init(row) {
      if (!!row) {
        this.dialogObj.title = "编辑订单价格计算规则";
        let arr1 = [
          row.startProvinceCode,
          row.startCityCode,
          row.startDistrictCode,
        ];
        let arr2 = [row.endProvinceCode, row.endCityCode, row.endDistrictCode];
        this.form.startDot = [...arr1];
        this.form.endDot = [...arr2];
        this.form.pricingId = row.pricingId;
        this.form.lineType = row.lineType;
        this.form.endCityCode = row.endCityCode;
        this.form.endCityName = row.endCityName;
        this.form.endProvinceCode = row.endProvinceCode;
        this.form.endProvinceName = row.endProvinceName;
        this.form.endDistrictCode = row.endDistrictCode;
        this.form.endDistrictName = row.endDistrictName;
        this.form.startCityCode = row.startCityCode;
        this.form.startCityName = row.startCityName;
        this.form.startProvinceCode = row.startProvinceCode;
        this.form.startProvinceName = row.startProvinceName;
        this.form.startDistrictCode = row.startDistrictCode;
        this.form.startDistrictName = row.startDistrictName;
        this.form.rules = row.rules;
        this.form.kilometres = row.kilometres;
      } else {
        this.dialogObj.title = "新增订单价格计算规则";
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.pricingId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            pricingId: this.form.pricingId,
            rules: this.form.rules,
            lineType: this.form.lineType,
            kilometres: this.form.kilometres,
            endCityCode: this.form.endCityCode,
            endCityName: this.form.endCityName,
            endProvinceCode: this.form.endProvinceCode,
            endProvinceName: this.form.endProvinceName,
            endDistrictCode: this.form.endDistrictCode,
            endDistrictName: this.form.endDistrictName,
            startCityCode: this.form.startCityCode,
            startCityName: this.form.startCityName,
            startProvinceCode: this.form.startProvinceCode,
            startProvinceName: this.form.startProvinceName,
            startDistrictCode: this.form.startDistrictCode,
            startDistrictName: this.form.startDistrictName,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.pricingId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.pricingId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .arrow-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow-img {
    width: 0.24rem;
    height: 0.025rem;
    position: relative;
    top: 0.45rem;
  }
}
</style>
